import { render, staticRenderFns } from "./SettingsModuleComponent.vue?vue&type=template&id=7af08a8a&scoped=true&"
import script from "./SettingsModuleComponent.vue?vue&type=script&lang=ts&"
export * from "./SettingsModuleComponent.vue?vue&type=script&lang=ts&"
import style0 from "./SettingsModuleComponent.vue?vue&type=style&index=0&id=7af08a8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af08a8a",
  null
  
)

export default component.exports